import { OpenInNewIcon } from "@mgdx/ui/components/Icon";
import { ListStyleMarker } from "@mgdx/ui/components/ListStyleMarker";
import { cx } from "cva";
import React from "react";

import { SubtleButtonProps, variants } from ".";
import * as styles from "./SubtleButton.module.css";

export const SubtleButtonExternalBulletLink = ({
  className,
  children,
  align,
  radius,
  title,
  target = "_blank",
  rel = "noopener noreferrer",
  disabled,
  ...props
}: Readonly<SubtleButtonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>>) => (
  <a
    title={title && `${title}(別ウィンドウで開きます)`}
    aria-disabled={disabled}
    target={target}
    rel={rel}
    className={cx(variants({ align, radius }), styles.bullet, className)}
    {...props}
  >
    <span className="flex items-start">
      <ListStyleMarker className="shrink-0" />
      <span>
        {children}
        <OpenInNewIcon size="s" className="mb-1 ml-1 inline" />
      </span>
    </span>
  </a>
);
